// extracted by mini-css-extract-plugin
export default {"primaryButton":"Button_primaryButton__fg3-d"};